module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "gfooter"
  }, [_c('nav', {
    staticClass: "gfooter__nav"
  }, [_c('ul', {
    staticClass: "gfooter__nav__list"
  }, [_c('li', {
    staticClass: "gfooter__nav__list__item"
  }, [_c('a', {
    staticClass: "gfooter__nav__list__item__link",
    on: {
      "click": _vm.goKisoku
    }
  }, [_vm._v("就業規則")])]), _c('li', {
    staticClass: "gfooter__nav__list__item"
  }, [_c('router-link', {
    staticClass: "gfooter__nav__list__item__link",
    attrs: {
      "to": "/company_notice_list"
    }
  }, [_vm._v("全社通達一覧")])], 1), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "gfooter__nav__list__item"
  }, [_c('a', {
    staticClass: "gfooter__nav__list__item__link",
    attrs: {
      "href": "/static/pdf/harassment.pdf",
      "target": "_blank"
    }
  }, [_vm._v("ハラスメント防止規程")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ffad2c62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-footer.pug
// module id = 1453
// module chunks = 1